import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';

export type Meta = {
  title: string;
  authRequired: boolean;
  beforeResolve?: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => void;
};
export default [
  {
    path: '/',
    redirect: { name: 'mypage' },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../pages/login/index.vue'),
    meta: {
      title: 'ログイン',
      authRequired: false,
    },
  },
  {
    path: '/tmp-register',
    name: 'temporaryRegister',
    component: () => import('../pages/register-user/index.vue'),
    meta: {
      title: '施設申込',
      authRequired: false,
    },
  },
  {
    path: '/cpl-register',
    name: 'completionOfRegistration',
    component: () => import('../pages/register-user/complete.vue'),
    meta: {
      title: '施設申込完了',
      authRequired: false,
    },
  },
  {
    path: '/forgot-password',
    name: 'forgotPassword',
    component: () => import('../pages/password/forgot.vue'),
    meta: {
      title: 'パスワード再発行',
      authRequired: false,
    },
  },
  {
    path: '/change-password',
    name: 'changePassword',
    component: () => import('../pages/password/index.vue'),
    meta: {
      title: 'パスワード再設定',
      authRequired: false,
    },
  },
  {
    path: '/mypage',
    name: 'mypage',
    meta: {
      title: '登録情報',
      authRequired: true,
    },
    component: () => import('../pages/mypage/index.vue'),
  },
  {
    path: '/edit-mail',
    name: 'editMailAddress',
    meta: {
      title: 'メールアドレス変更届',
      authRequired: true,
    },
    component: () => import('../pages/edit-mail/index.vue'),
  },
  {
    path: '/cpl-change-email',
    name: 'completeChangeMailAddress',
    meta: {
      title: 'メールアドレス本登録完了',
      authRequired: true,
    },
    component: () => import('../pages/edit-mail/complete.vue'),
  },
  {
    path: '/screening',
    name: 'screening',
    meta: {
      title: '認定施設トップページ',
      authRequired: true,
      proxyLogin: true,
    },
    component: () => import('../pages/screening/index.vue'),
  },
  {
    path: '/screening-basic-info/:entryId',
    name: 'screeningBasicInfo',
    meta: {
      title: '申請1 基本情報登録',
      authRequired: true,
    },
    component: () => import('../pages/screening/basic-info/index.vue'),
  },
  {
    path: '/screening-med-edu-info/:entryId',
    name: 'screeningMedEduInfo',
    meta: {
      title: '申請2 診療・教育体制体制概要登録',
      authRequired: true,
    },
    component: () => import('../pages/screening/med-edu-info/index.vue'),
  },
  {
    path: '/edit-user',
    name: 'editUserInfo',
    meta: {
      title: '変更届',
      authRequired: true,
    },
    component: () => import('../pages/edit-user/index.vue'),
  },
  {
    path: '/certified-user-list',
    name: 'certifiedUserList',
    meta: {
      title: '認定医名簿​',
      authRequired: true,
    },
    component: () => import('../pages/user-list/index.vue'),
  },
  {
    path: '/facility-list',
    name: 'facilityList',
    meta: {
      title: '施設名簿​',
      authRequired: true,
    },
    component: () => import('../pages/facility-list/index.vue'),
  },
  {
    path: '/auth/500',
    name: '500Error',
    meta: {
      title: 'Error 500',
      authRequired: true,
    },
    component: () => import('../views/errors/500.vue'),
  },
  {
    path: '/:catchAll(.*)', // すべてのパスにマッチ
    name: 'NotFound',
    meta: {
      title: 'Error 404',
      authRequired: false,
    },
    component: () => import('../views/errors/404-cover.vue'),
  },
];
